module.exports = __webpack_public_path__ + "img/redEnvelopedRainContactImage.847417d3.png";